import { useEffect, useState } from 'react'
import { Dimensions, useNodes } from '@xyflow/react'

type useNodeSizesProps = {
  nodeId: string
}

export default function useModelNodeMeasurements({
  nodeId,
}: useNodeSizesProps) {
  const nodes = useNodes()

  const [modelNodeMeasurements, setModelNodeMeasurements] =
    useState<Dimensions>({
      height: 0,
      width: 0,
    })

  useEffect(() => {
    if (!modelNodeMeasurements.width) {
      const targetNode = nodes.find((node) => node.id === nodeId)
      if (targetNode) {
        setModelNodeMeasurements({
          height: targetNode.measured?.height || 0,
          width: targetNode.measured?.width || 0,
        })
      }
    }
  }, [modelNodeMeasurements.width, nodes, nodeId])

  return modelNodeMeasurements
}
